// Skills

export const SKILLS = {
  // Programming Languages
  TYPESCRIPT: 'TypeScript',
  JAVASCRIPT: 'JavaScript',
  PYTHON: 'Python',
  PHP: 'PHP',
  JAVA: 'Java',
  C_SHARP: 'C#',

  // Frontend
  REACT: 'React',
  ANGULAR: 'Angular',
  VUE: 'Vue.js',
  HTML: 'HTML',
  CSS: 'CSS',
  SASS: 'Sass',

  // Backend
  NODE: 'Node.js',
  EXPRESS: 'Express.js',
  LARAVEL: 'Laravel',
  DJANGO: 'Django',
  SYMFONY: 'Symfony',

  // Mobile
  REACT_NATIVE: 'React Native',
  IONIC: 'Ionic',
  EXPO: 'Expo',

  // Databases
  MYSQL: 'MySQL',
  POSTGRESQL: 'PostgreSQL',
  MONGODB: 'MongoDB',
  DYNAMODB: 'DynamoDB',

  // DevOps
  DOCKER: 'Docker',
  KUBERNETES: 'Kubernetes',
  AWS: 'AWS',
  CI_CD: 'CI/CD',

  // Other
  GIT: 'Git',
  LINUX: 'Linux',
  AGILE: 'Agile',
  SCRUM: 'Scrum',
};
